import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
export function Dropdown(props) {
    const [open, setOpen] = useState(false);
    const menuRef = React.useRef(null);
    const clickListener = () => {
        setOpen(false);
    };
    function click(e) {
        if (!open) {
            e.stopPropagation();
            setOpen(true);
            document.addEventListener('click', clickListener, { once: true, passive: true });
        }
    }
    return (_jsxs(React.Fragment, { children: [_jsxs("a", { onClick: click, style: { whiteSpace: 'nowrap' }, children: [props.button, " ", _jsx("span", { className: "caret" })] }), _jsx("div", { ref: menuRef, role: "menu", style: { display: open ? 'block' : 'none' }, children: props.children })] }));
}
